// @givmo/fundraisers-module — the appeal's Social tab's one read (EMC-WEB5): `GET /org/{org_ref}/fundraisers/
// {fundraiser_id}/social`, the campaign's posts rented from Social under the Fundraisers gate. The committed
// OpenAPI snapshot carries no campaign-email family, so the call uses the configured `givmoClient` escape
// hatch (`emails-transport.ts`' precedent). A route miss or a refusal is an ANSWER (no Social here): no retry.

import { givmoClient, isGivmoError } from '@givmo/api-client';
import { decodeCampaignSocial } from './campaign-social-decode';

const retry = (failureCount: number, error: unknown) =>
  !(isGivmoError(error) && (error.status === 404 || error.status === 403)) && failureCount < 1;

export const campaignSocialKeys = {
  all: ['fundraisers-module', 'campaign-social'] as const,
  posts: (orgRef: string, fundraiserId: string) =>
    [...campaignSocialKeys.all, orgRef, fundraiserId] as const,
};

export async function fetchCampaignSocial(
  orgRef: string,
  fundraiserId: string,
  options: { signal?: AbortSignal } = {},
): Promise<unknown> {
  const { data } = await givmoClient.get({
    url: `/org/${encodeURIComponent(orgRef)}/fundraisers/${encodeURIComponent(fundraiserId)}/social`,
    signal: options.signal,
    throwOnError: true,
  });
  return data;
}

export function campaignSocialOptions(orgRef: string, fundraiserId: string) {
  return {
    queryKey: campaignSocialKeys.posts(orgRef, fundraiserId),
    queryFn: ({ signal }: { signal: AbortSignal }) =>
      fetchCampaignSocial(orgRef, fundraiserId, { signal }).then(decodeCampaignSocial),
    retry,
  };
}
